export default {

  productList: [],
  preSelectedProduct: null,
  selectedProduct: null,
  cartEntry: {},
  carts: [{
    id: 0,
    cartEntries: [],
    totalPrice: 0,
    active: true,
    isNavigatedByQuestion: false
  }],
  screenLock : true,
  isLoading:false,
  activePersonal : null,
  personList:[],
  toUpdateEntry : null,
  isReset : false,
  lastBillId : 0,
  paymentMethods : [{}],
  selectedPaymentMethod : null,
  isLossModeOn : false,
  lossTypeSelection: true,
  selectedLossStocks:[],
  isCakeQuestioned : false,
  navigationQuestion: {},
  hasNeedNavigationByQuestion: false,
  notifications: []
};
